<template>
	<div>
		<div class="view-title">
			{{ $route.query.accountName || attrText.members }}
		</div>
		<div class="workgroup-wrapper">
			<!--tab 栏-->
			<el-tabs type="card" :active-name="m.currentTab">
				<!--工作组-->
				<el-tab-pane :label="attrText.workgroup" name="workgroup">
					<div class="add-ssk">
						<el-button type="text" @click.stop="onShowAccountAddWorkgroup()">
							<i class="fa fa-graduation-cap fa-lg"></i>
							<translate>Distribute</translate>
						</el-button>
						<el-button type="text" @click="batchDel(m.batchDel)" :disabled="m.batchDel === ''">
							<i class="fa fa-trash fa-lg"></i>
							<translate>Exit</translate>
						</el-button>
					</div>
					<el-table ref="memberTable" v-loading="loading" :data="m.accountWorkgroupList" style="width: 100%" :row-class-name="tableRowClassName" @selection-change="onSelectionChange">
						<el-table-column type="selection" width="30"></el-table-column>
						<el-table-column :label="attrText.name">
							<template scope="scope">
								<span>{{ scope.row.project_name }}</span>
								<el-tooltip class="item" effect="dark" :content="attrText.defaultWorkgroup" placement="top" v-if="scope.row.network_id !== -1">
									<i class="fa fa-globe" aria-hidden="true"></i>
								</el-tooltip>
							</template>
						</el-table-column>
						<el-table-column :label="attrText.desc">
							<template scope="scope">
								{{ scope.row.desc }}
							</template>
						</el-table-column>

						<el-table-column :label="attrText.action" width="180">
							<template scope="scope">
								<el-button type="text" @click="batchDel(scope.row.id)">
									<translate>Exit</translate>
								</el-button>
							</template>
						</el-table-column>
					</el-table>
					<div class="pagination" v-if="m.totalPage > 10 && m.currentTab === 'workgroup'">
						<el-pagination layout="total, prev, pager, next" :total="m.totalPage" :current-page.sync="m.currentPage" :page-size="10" @current-change="onChangePage"></el-pagination>
					</div>
				</el-tab-pane>
			</el-tabs>
		</div>

		<component :is="currentRightPanel" :items="rightPanelData" @onClosePanel="onClosePanel" @callback="callback"></component>
	</div>
</template>

<script>
import STORE_CONST from '../../store/consts'
import AccountAddWorkgroup from './model/account-add-workgroup'
export default {
	data() {
		return {
			loading: false,
			m: {
				currentTab: this.$route.query.type || 'workgroup',
				totalPage: 1,
				currentPage: 1,
				accountWorkgroupList: [],
				workgroupList: [],
				batchDel: '',
				members: [],
				isHaveNet: false,
				groups: [],
			},
			clusterIds: [],
			clusterList: {},
			currentRightPanel: null,
			rightPanelData: null,
		}
	},
	computed: {
		attrText() {
			return this.getTranslateText()
		},
	},
	created() {
		this.getAccountWorkGroupList()
		// this.onRouteChange()
	},
	methods: {
		// 提取翻译文本
		getTranslateText() {
			return {
				servers: this.$gettext('Servers'),
				dataBase: this.$gettext('DataBases'),
				members: this.$gettext('Member'),
				workgroup: this.$gettext('Workgroup'),
				group: this.$gettext('Group'),
				name: this.$gettext('Name'),
				cluster: this.$gettext('Cluster'),
				loginUsername: this.$gettext('Login Username'),
				os: this.$gettext('OS'),
				action: this.$gettext('Action'),
				Specification: this.$gettext('Specification'),
				dataBaseName: this.$gettext('Database Name'),
				ipConnect: this.$gettext('IP/Connection String'),
				type: this.$gettext('Type'),
				email: this.$gettext('Email'),
				administrator: this.$gettext('administrator'),
				ordinary: this.$gettext('Ordinary Member'),
				defaultWorkgroup: this.$gettext('default workgroup'),
				selectCluster: this.$gettext('Select Cluster'),
				selectInstance: this.$gettext('Select Resource'),
				selectedInstance: this.$gettext('Selected Instance'),
				selectedDatabase: this.$gettext('Selected Database'),
				hostName: this.$gettext('Host name / IP'),
				account: this.$gettext('Account'),
				desc: this.$gettext('Desc'),
			}
		},
		// 获取成员下工作组
		getAccountWorkGroupList() {
			this.loading = true
			let params = {
				id: this.$route.params.id,
			}
			this.$store.dispatch(STORE_CONST.WORKGROUP.GET_ACCOUNT_WORKGROUP_LIST, params).then((res) => {
				console.log(res, 'res')
				this.m.accountWorkgroupList = res
				this.loading = false
			})
		},

		// 获取工作组列表
		getWorkGroupList(page) {
			this.m.currentPage = page || 1
			this.loading = true
			let params = {
				page: page || 1,
			}
			this.$store.dispatch(STORE_CONST.WORKGROUP.LIST_WORKGROUP, params).then((res) => {
				this.m.totalPage = res.total
				this.m.workgroupList = res.objects
				this.loading = false
			})
		},

		// Exit工作组
		batchDel(id) {
			this.$confirm(this.$gettext('Are You Sure To Exit The Selected Working Group?'), this.$gettext('Exit Confirm'), {
				confirmButtonText: this.$gettext('Ok'),
				cancelButtonText: this.$gettext('Cancel'),
				type: 'warning',
			}).then(() => {
				if (this.$route.query.type === 'workgroup') {
					let params = {
						account_id: this.$route.params.id,
						project_ids: id.toString(),
					}
					this.$store.dispatch(STORE_CONST.WORKGROUP.DEL_ACCOUNT_WORKGROUP, params).then(() => {
						this.$notify({
							type: 'success',
							message: this.$gettext('Exit successfully!'),
						})
						this.getAccountWorkGroupList()
					})
				}
			})
		},
		// 选择批量删除的
		onSelectionChange(select) {
			if (select.length !== 0) {
				this.m.batchDel = select.map((item) => item.id).join(',')
			} else {
				this.m.batchDel = ''
			}
			console.log('del', this.m.batchDel)
		},
		// 切换tab
		/* onTabClick(tab) {
			this.$router.push({ name: 'settingWorkgroupDetail', query: { type: tab.name } })
			this.detail = Object.assign({}, this.detail, {
				currentTab: this.$route.query.type || 'ecs',
				batchDel: '',
				currentPage: 1,
			})
			this.$refs.memberTable.clearSelection()
			this.$refs.groupTable.clearSelection()
			console.log('this.m.batchDel---', this.m.batchDel)
		}, */
		// route change
		/* onRouteChange() {
			if (this.$route.query.type === 'member') {
				this.getMemberList()
			} else if (this.$route.query.type === 'group') {
				this.getGroupList()
			} else {
				this.getWorkGroupList()
			}
		}, */
		// 分页
		onChangePage(page) {
			this.getWorkGroupList(page)
		},
		// 关闭侧滑回调
		onClosePanel() {
			this.currentRightPanel = null
			this.rightPanelData = null
		},
		// 传给侧滑的回调函数
		callback() {
			return this.getAccountWorkGroupList()
		},

		// 显示添加成员
		onShowAccountAddWorkgroup(row) {
			const time = !this.currentRightPanel || this.currentRightPanel.name === 'AccountAddWorkgroup' ? 0 : 300
			this.currentRightPanel = AccountAddWorkgroup
			this.$nextTick(() => {
				setTimeout(() => {
					this.rightPanelData = row || []
				}, time)
			})
		},
		tableRowClassName(row, index) {
			if (index % 2 === 0) {
				return 'info-row'
			}
			return ''
		},
	},
	watch: {
		$route(to, from) {
			this.m.currentTab = this.$route.query.type
			// this.onRouteChange()
		},
	},
	components: {
		AccountAddWorkgroup,
	},
}
</script>

<style lang="scss" rel="stylesheet/scss">
@import '../../assets/css/variable';

.workgroup-wrapper {
	.el-table-column--selection {
		.cell {
			padding-left: 11px;
			padding-right: 14px;
		}
	}
}

.add-ssk {
	height: 60px;
	line-height: 60px;
	padding: 0 15px;
	background-color: #fff;
	border: 1px solid $border-color;
	border-bottom: none;
	.el-button--text {
		color: $textColor;
		&:hover {
			color: $mainColor;
		}
		&.is-disabled {
			color: $textColor;
		}
	}
}

.table-wrapper {
	padding: 0 20px;
}
</style>



// WEBPACK FOOTER //
// team-account-workgroup.vue?078d256f